// ═══ SETĂRI TAB ══════════════════════════════════════════════════════════════
// Notificări, preferințe, aspect, dispozitive conectate, securitate, suport, cont.
import React from "react";
import { fmAlert } from './dialog';
import { validatePassword } from './helpers';
import { verifyPassword, updatePassword, setEmail2FA, isEmail2FAEnabled } from './supabase';
import { playAlarm } from './notifications';
import { Dropdown, PasswordChecklist } from './ui';
import { ThemeSelector } from './theme';
import { t, getLang, setLang } from './i18n';

// Rând cu comutator (switch) pentru setări
export function SettingRow({label, checked, onChange, disabled=false, soon=false}) {
  return (
    <div style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:"1px solid var(--border)",opacity:disabled&&!soon?0.5:1}}>
      <div style={{flex:1,minWidth:0,fontSize:14,display:"flex",alignItems:"center",gap:8}}>{typeof label==="string"?t(label):label}{soon&&<span style={{fontSize:9,letterSpacing:".05em",textTransform:"uppercase",color:"var(--purple)",background:"var(--purple-bg)",border:"1px solid var(--purple-line)",padding:"1px 6px",borderRadius:999}}>{t("în curând")}</span>}</div>
      <label className="toggle" style={{cursor:disabled?"not-allowed":"pointer"}}>
        <input type="checkbox" checked={!!checked} disabled={disabled} onChange={e=>!disabled&&onChange(e.target.checked)}/>
        <span className="slider"/>
      </label>
    </div>
  );
}

// Logo-uri de brand reale (SVG inline, fără resurse externe)
export function BrandLogo({app, size=24}) {
  if(app==="google") return (
    // Google Fit — inima în cele 4 culori Google
    <svg viewBox="0 0 256 216" width={size} height={Math.round(size*216/256)} style={{flexShrink:0,display:"block"}} aria-hidden="true">
      <path fill="#EA4335" d="M55.5774312,0.518934349 C69.9640298,-1.34690438 84.9125622,1.8555732 97.2260067,9.53169919 C104.176529,13.6289064 109.735855,19.5592184 115.437029,25.1731016 C119.572426,29.2212078 123.664178,33.3184151 127.810486,37.35561 L127.963245,37.7756965 C124.865978,40.8249722 121.351577,46.9222616 117.420043,56.0675647 C109.17447,58.9683238 103.546988,61.8965291 100.537598,64.8521807 C93.8216694,58.3872132 87.3239678,51.6931076 80.6353179,45.1954061 C74.2740081,39.2378157 64.6611197,36.8373215 56.3303135,39.5706115 C46.8429054,42.2384336 39.603233,51.3112108 39.1013114,61.1586929 C38.7739713,66.2815659 40.1106102,71.4862739 42.8820899,75.8071636 C44.6060812,78.5895547 47.1266002,80.7118099 49.3852471,83.0359248 C54.8136375,88.4915936 60.372964,93.821782 65.7195194,99.3538301 C62.8643828,102.159652 59.4836867,107.591131 55.5774312,115.648267 C47.2683739,119.586376 41.5035506,123.167662 38.2829611,126.392125 C31.0651113,119.605273 24.1636903,112.452891 17.0113085,105.58966 C8.49500953,96.7296534 2.79929132,85.2345593 0.835250554,73.1066076 C-1.32519429,60.0948375 0.726137178,46.3956532 6.74919552,34.6495983 C11.8066005,24.8021161 19.4609038,16.2476275 28.7737304,10.2409361 C36.8699429,5.15079715 46.0409221,1.58278976 55.5774312,0.518934349 Z"/>
      <polygon fill="#34A853" points="128.083269 160.779205 190.490665 99.2719951 207.36413 109.294059 217.921767 126.452137 128.083269 215.330437 65.7631648 153.675924 77.7221592 136.846613 93.3633932 126.430314"/>
      <polygon fill="#FBBC05" points="100.592154 64.9121931 116.289402 73.4031101 128.083269 92.1687143 65.7631648 153.675924 38.2829611 126.392125"/>
      <path fill="#4285F4" d="M203.333309,0.895375496 C221.620711,3.99419537 238.440538,15.4129101 247.660618,31.5671454 C258.16278,49.314436 258.735625,72.3428139 249.417343,90.7065951 C245.55473,98.5954921 239.657152,105.251408 233.377677,111.301745 C228.167513,116.28277 223.219222,121.596592 217.921767,126.452137 C208.756244,117.417549 199.579809,108.388418 190.490665,99.2719951 C196.966543,92.7306482 203.54608,86.2984147 210.043782,79.7788905 C214.233735,75.5452915 216.857912,69.7404599 217.070683,63.7665026 C217.359833,56.9851063 214.6811,50.105508 209.765542,45.4027215 C204.757239,40.6617453 197.741248,37.9666449 190.834372,38.5394901 C184.893148,38.8231849 179.159241,41.5182853 174.969287,45.7191503 C159.33334,61.1914269 143.735583,76.707349 128.083269,92.1687143 C118.879556,83.1232155 109.664932,74.088628 100.592154,64.9121931 C100.581243,64.895826 100.553965,64.8685477 100.537598,64.8521807 C109.703121,55.8503272 118.808632,46.7884613 127.963245,37.7756965 C134.597338,31.2398053 141.209608,24.6766357 147.849157,18.1352889 C156.447291,9.49896517 167.784171,3.84143664 179.628428,1.2445383 C187.43549,-0.223036606 195.488057,-0.38670667 203.333309,0.895375496 Z"/>
    </svg>
  );
  if(app==="apple") return (
    // Apple — mărul mușcat (se adaptează la temă)
    <svg viewBox="0 0 256 315" width={Math.round(size*256/315)} height={size} style={{flexShrink:0,display:"block"}} aria-hidden="true">
      <path fill="var(--text)" d="M213.803394,167.030943 C214.2452,214.609646 255.542482,230.442639 256,230.644727 C255.650812,231.761357 249.401383,253.208293 234.24263,275.361446 C221.138555,294.513969 207.538253,313.596333 186.113759,313.991545 C165.062051,314.379442 158.292752,301.507828 134.22469,301.507828 C110.163898,301.507828 102.642899,313.596301 82.7151126,314.379442 C62.0350407,315.16201 46.2873831,293.668525 33.0744079,274.586162 C6.07529317,235.552544 -14.5576169,164.286328 13.147166,116.18047 C26.9103111,92.2909053 51.5060917,77.1630356 78.2026125,76.7751096 C98.5099145,76.3877456 117.677594,90.4371851 130.091705,90.4371851 C142.497945,90.4371851 165.790755,73.5415029 190.277627,76.0228474 C200.528668,76.4495055 229.303509,80.1636878 247.780625,107.209389 C246.291825,108.132333 213.44635,127.253405 213.803394,167.030988 M174.239142,50.1987033 C185.218331,36.9088319 192.607958,18.4081019 190.591988,0 C174.766312,0.636050225 155.629514,10.5457909 144.278109,23.8283506 C134.10507,35.5906758 125.195775,54.4170275 127.599657,72.4607932 C145.239231,73.8255433 163.259413,63.4970262 174.239142,50.1987249"/>
    </svg>
  );
  if(app==="garmin") return (
    // Garmin — emblema (delta albastru); numele „Garmin" apare ca text lângă
    <svg viewBox="0 0 24 24" width={size} height={size} style={{flexShrink:0,display:"block"}} aria-hidden="true">
      <path d="M12 3.2 21 20.2a1 1 0 0 1-.88 1.5H3.88A1 1 0 0 1 3 20.2L12 3.2z" fill="#007CC3"/>
    </svg>
  );
  return null;
}

// Rând pentru o aplicație de sănătate care se poate conecta (deocamdată „în curând")
function HealthAppRow({app, name, last=false}) {
  return (
    <div style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:last?"none":"1px solid var(--border)"}}>
      <div style={{width:28,display:"flex",justifyContent:"center",flexShrink:0}}><BrandLogo app={app}/></div>
      <div style={{flex:1,minWidth:0,fontSize:14,display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>{name}<span style={{fontSize:9,letterSpacing:".05em",textTransform:"uppercase",color:"var(--purple)",background:"var(--purple-bg)",border:"1px solid var(--purple-line)",padding:"1px 6px",borderRadius:999}}>{t("în curând")}</span></div>
      <button className="bg" disabled style={{fontSize:12,padding:"6px 12px",opacity:.5,cursor:"not-allowed",whiteSpace:"nowrap"}}>{t("Conectează")}</button>
    </div>
  );
}

// Toggle 2FA pe email — la login primești un cod pe email
function TwoFactorToggle({session}) {
  const [on, setOn] = React.useState(isEmail2FAEnabled(session));
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState("");
  async function toggle(v){
    setBusy(true); setErr(""); setOn(v);
    const res = await setEmail2FA(v);
    setBusy(false);
    if(!res.ok){ setOn(!v); setErr(res.message||t("Nu am putut salva setarea.")); }
  }
  return (
    <div>
      <div style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",opacity:busy?0.6:1}}>
        <div style={{flex:1,minWidth:0,fontSize:14}}>{t("Autentificare în 2 pași (2FA)")}<div style={{fontSize:11.5,color:"var(--text-3)",marginTop:2}}>{t("Primești un cod pe email la fiecare autentificare.")}</div></div>
        <label className="toggle" style={{cursor:busy?"wait":"pointer"}}>
          <input type="checkbox" checked={on} disabled={busy} onChange={e=>toggle(e.target.checked)}/>
          <span className="slider"/>
        </label>
      </div>
      {err&&<div style={{fontSize:12,color:"var(--red)"}}>{err}</div>}
    </div>
  );
}

export function ProfileTab({session, patient, notifSettings, onSaveNotif, showCycle=false, cycleNotify, onSaveCycleNotify, activeProfileName, onDeleteProfile, onDeleteAccount, onSignOut, onExportData, onImportData}) {
  const importRef = React.useRef(null);
  const email = session?.user?.email || "";
  const ns = notifSettings || {};
  const set = (patch)=> onSaveNotif({ ...ns, ...patch });
  const cn = cycleNotify || {};
  const setCycle = (patch)=> onSaveCycleNotify({ daysBefore:3, time:"09:00", ...cn, ...patch });

  // ── schimbare parolă (cere parola actuală) ──
  const [pwCur, setPwCur] = React.useState(""); const [pw1, setPw1] = React.useState(""); const [pw2, setPw2] = React.useState("");
  const [pwMsg, setPwMsg] = React.useState(""); const [pwErr, setPwErr] = React.useState(""); const [pwBusy, setPwBusy] = React.useState(false);
  const [showPwForm, setShowPwForm] = React.useState(false);
  function resetPwForm(){ setShowPwForm(false); setPwErr(""); setPwCur(""); setPw1(""); setPw2(""); }
  async function changePassword(){
    setPwErr(""); setPwMsg("");
    if(!pwCur){ setPwErr(t("Introdu parola actuală.")); return; }
    const e = validatePassword(pw1); if(e){ setPwErr(e); return; }
    if(pw1!==pw2){ setPwErr(t("Parolele noi nu coincid.")); return; }
    setPwBusy(true);
    const ok = await verifyPassword(pwCur);
    if(!ok){ setPwBusy(false); setPwErr(t("Parola actuală este greșită.")); return; }
    const res = await updatePassword(pw1);
    setPwBusy(false);
    if(res.ok){ setPwMsg(t("Parola a fost schimbată.")); resetPwForm(); }
    else setPwErr(res.message || t("Nu am putut schimba parola. Încearcă din nou."));
  }

  // ── permisiune notificări (browser) ──
  const [notifPerm, setNotifPerm] = React.useState(typeof Notification!=="undefined" ? Notification.permission : "unsupported");
  async function askNotifPermission(){
    if(typeof Notification==="undefined"){ fmAlert(t("Dispozitivul nu suportă notificări web.")); return; }
    const p = await Notification.requestPermission();
    setNotifPerm(p);
    if(p==="granted"){ try{ new Notification("Fișă Medicală", {body:t("Notificările sunt active ✓")}); }catch(e){} }
  }

  // ── legal expandabil ──
  const [openLegal, setOpenLegal] = React.useState(null);

  const num = (v,def)=>{ const n=parseInt(v,10); return isNaN(n)?def:n; };

  return (
    <div>
      {/* Notificări */}
      <div className="sec" style={{margin:"4px 0 10px"}}>{t("Notificări")}</div>
      {notifPerm!=="granted"&&notifPerm!=="unsupported"&&(
        <div style={{marginBottom:12,padding:"11px 13px",background:"var(--blue-bg-soft)",border:"1px solid var(--blue-line)",borderRadius:10,fontSize:12.5,color:"var(--blue-2)",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
          <span>{t("Permite notificările pe acest dispozitiv")}</span>
          <button className="bp" style={{fontSize:12,padding:"7px 12px"}} onClick={askNotifPermission}>{t("Permite")}</button>
        </div>
      )}
      <div className="card">
        <SettingRow label="Notificări active" checked={ns.enabled} onChange={v=>set({enabled:v})}/>
        <SettingRow label="Alarmă la ora medicamentelor" checked={ns.med_time_enabled} disabled={!ns.enabled} onChange={v=>set({med_time_enabled:v})}/>
        <SettingRow label="Alertă stoc pe terminate" checked={ns.med_stock_enabled} disabled={!ns.enabled} onChange={v=>set({med_stock_enabled:v})}/>
        <SettingRow label="Reminder programări" checked={ns.appt_enabled} disabled={!ns.enabled} onChange={v=>set({appt_enabled:v})}/>
        {showCycle&&<SettingRow label="Notificare menstruație" checked={!!cn.enabled} disabled={!ns.enabled} onChange={v=>setCycle({enabled:v})}/>}
        <div style={{fontSize:11.5,color:"var(--text-3)",marginTop:10,lineHeight:1.5}}>{t("Valorile de mai jos sunt pre-completate când adaugi un medicament sau o programare; le poți schimba sau opri individual pentru fiecare.")}</div>
      </div>

      <div className="sec" style={{margin:"18px 0 10px"}}>{t("Preferințe implicite")}</div>
      <div className="card" style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
          <div style={{flex:1,fontSize:14}}>{t("Alertă stoc înainte cu")}</div>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <input type="number" min="1" max="30" value={ns.stock_days_before??3} onChange={e=>set({stock_days_before:num(e.target.value,3)})} style={{width:64,textAlign:"center"}}/>
            <span style={{fontSize:13,color:"var(--text-2)"}}>{t("zile")}</span>
          </div>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
          <div style={{flex:1,fontSize:14}}>{t("Reminder programare înainte cu")}</div>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <input type="number" min="1" max="168" value={ns.appt_hours_before??24} onChange={e=>set({appt_hours_before:num(e.target.value,24)})} style={{width:64,textAlign:"center"}}/>
            <span style={{fontSize:13,color:"var(--text-2)"}}>{t("ore")}</span>
          </div>
        </div>
        {showCycle&&cn.enabled&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
              <div style={{flex:1,fontSize:14}}>{t("Menstruație — anunț înainte cu")}</div>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <input type="number" min="1" max="7" value={cn.daysBefore??3} onChange={e=>setCycle({daysBefore:parseInt(e.target.value)||3})} style={{width:64,textAlign:"center"}}/>
                <span style={{fontSize:13,color:"var(--text-2)"}}>{t("zile")}</span>
              </div>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
              <div style={{flex:1,fontSize:14}}>{t("Menstruație — la ora")}</div>
              <input type="time" value={cn.time||"09:00"} onChange={e=>setCycle({time:e.target.value})} style={{width:110}}/>
            </div>
          </>
        )}
        <div>
          <div className="lbl">{t("Sunet alarmă")}</div>
          <div style={{display:"flex",gap:8}}>
            <div style={{flex:1}}><Dropdown value={ns.sound||"default"} onChange={v=>set({sound:v})}
              options={[{v:"default",l:"Implicit"},{v:"clopotel",l:"Clopoțel"},{v:"bip",l:"Bip"},{v:"melodie",l:"Melodie blândă"}]}/></div>
            <button className="bg" style={{whiteSpace:"nowrap"}} onClick={()=>playAlarm(ns.sound||"default")}>{t("🔊 Testează")}</button>
          </div>
        </div>
        <div>
          <div className="lbl">{t("Ore de liniște")}</div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <input type="time" value={ns.quiet_from||""} onChange={e=>set({quiet_from:e.target.value||null})} style={{flex:1}}/>
            <span style={{color:"var(--text-3)"}}>→</span>
            <input type="time" value={ns.quiet_to||""} onChange={e=>set({quiet_to:e.target.value||null})} style={{flex:1}}/>
          </div>
        </div>
      </div>

      {/* Aspect */}
      <div className="sec" style={{margin:"18px 0 10px"}}>{t("Aspect")}</div>
      <div className="card">
        <div style={{fontSize:14,marginBottom:10}}>{t("Temă")}</div>
        <ThemeSelector/>
        <div style={{fontSize:14,margin:"16px 0 10px"}}>{t("Limbă")}</div>
        <div style={{display:"flex",gap:6,background:"var(--bg)",border:"1px solid var(--border)",borderRadius:10,padding:4}}>
          {[["ro","RO · Română"],["en","EN · English"]].map(([v,l])=>(
            <button key={v} onClick={()=>setLang(v)}
              style={{flex:1,padding:"8px 6px",borderRadius:7,border:"none",cursor:"pointer",fontFamily:"inherit",fontSize:12.5,
                background: getLang()===v ? "#7c3aed" : "transparent",
                color: getLang()===v ? "#fff" : "var(--text-3)", fontWeight: getLang()===v?600:400}}>
              {l}
            </button>
          ))}
        </div>
      </div>

      {/* Aplicații de sănătate */}
      <div className="sec" style={{margin:"18px 0 10px"}}>{t("Aplicații de sănătate")}</div>
      <div className="card">
        <div style={{fontSize:12,color:"var(--text-3)",lineHeight:1.55,marginBottom:4}}>
          {t("Conectează o aplicație ca să imporți automat valori (puls, pași, somn, greutate, saturație, tensiune). Datele apar în")} <strong>{t("Analize → Dispozitive")}</strong>.
        </div>
        <HealthAppRow app="google" name="Google Health / Fit"/>
        <HealthAppRow app="garmin" name="Garmin"/>
        <HealthAppRow app="apple" name="Apple Health" last/>
      </div>

      {/* Securitate */}
      <div className="sec" style={{margin:"18px 0 10px"}}>{t("Securitate")}</div>
      <div className="card">
        <div style={{marginBottom:12}}><div className="lbl">{t("Email cont")}</div><div style={{fontSize:15,wordBreak:"break-all"}}>{email||"—"}</div></div>
        {!showPwForm ? (
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10}}>
            <div style={{fontSize:14}}>{t("Parolă")}</div>
            <button className="bg" onClick={()=>{setShowPwForm(true);setPwMsg("");}}>{t("Schimbă")}</button>
          </div>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <div><div className="lbl">{t("Parola actuală")}</div><input type="password" value={pwCur} onChange={e=>setPwCur(e.target.value)}/></div>
            <div>
              <div className="lbl">{t("Parolă nouă")}</div>
              <input type="password" value={pw1} onChange={e=>setPw1(e.target.value)}/>
              {pw1&&<PasswordChecklist value={pw1}/>}
            </div>
            <div><div className="lbl">{t("Confirmă parola nouă")}</div><input type="password" value={pw2} onChange={e=>setPw2(e.target.value)}/></div>
            {pwErr&&<div style={{fontSize:12,color:"var(--red)"}}>{pwErr}</div>}
            <div style={{display:"flex",gap:8}}>
              <button className="bp" disabled={pwBusy} onClick={changePassword}>{pwBusy?t("Se salvează…"):t("Salvează")}</button>
              <button className="bg" onClick={resetPwForm}>{t("Anulează")}</button>
            </div>
          </div>
        )}
        {pwMsg&&<div style={{fontSize:12,color:"var(--green)",marginTop:10}}>{pwMsg}</div>}
        <div style={{marginTop:14,paddingTop:8,borderTop:"1px solid var(--border)"}}>
          <TwoFactorToggle session={session}/>
          <SettingRow label="Deblocare cu biometrie" checked={false} soon disabled onChange={()=>{}}/>
        </div>
      </div>

      {/* Datele mele — backup */}
      {onExportData&&(
        <>
          <div className="sec" style={{margin:"18px 0 10px"}}>{t("Datele mele")}</div>
          <div className="card">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10}}>
              <div style={{flex:1,minWidth:0,fontSize:14}}>{t("Descarcă toate datele")}<div style={{fontSize:11.5,color:"var(--text-3)",marginTop:2}}>{t("Un fișier de backup (JSON) cu profilul, analizele, tratamentul, vaccinurile etc.")}</div></div>
              <button className="bg" style={{whiteSpace:"nowrap",flexShrink:0}} onClick={onExportData}>{t("⬇ Descarcă")}</button>
            </div>
            {onImportData&&(
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,marginTop:12,paddingTop:12,borderTop:"1px solid var(--border)"}}>
                <div style={{flex:1,minWidth:0,fontSize:14}}>{t("Încarcă un backup")}<div style={{fontSize:11.5,color:"var(--text-3)",marginTop:2}}>{t("Restaurează datele dintr-un fișier salvat anterior. Recomandat pe un profil gol.")}</div></div>
                <button className="bg" style={{whiteSpace:"nowrap",flexShrink:0}} onClick={()=>importRef.current&&importRef.current.click()}>{t("⬆ Încarcă")}</button>
                <input ref={importRef} type="file" accept="application/json,.json" style={{display:"none"}} onChange={e=>{ const f=e.target.files&&e.target.files[0]; e.target.value=""; if(f) onImportData(f); }}/>
              </div>
            )}
            <div style={{fontSize:11,color:"var(--text-4)",marginTop:10,lineHeight:1.5}}>{t("Include datele acestui profil (fără fișierele documentelor încărcate — doar denumirile și sumarele lor).")}</div>
          </div>
        </>
      )}

      {/* Suport & legal */}
      <div className="sec" style={{margin:"18px 0 10px"}}>{t("Suport și informații")}</div>
      <div className="card" style={{padding:"4px 14px"}}>
        <button onClick={()=>{ window.location.href=`mailto:cristinahasas@gmail.com?subject=${encodeURIComponent("Suport Fișă Medicală")}`; }} style={{display:"flex",justifyContent:"space-between",alignItems:"center",width:"100%",background:"none",border:"none",color:"var(--text)",padding:"12px 0",borderBottom:"1px solid var(--border)",cursor:"pointer",fontFamily:"inherit",fontSize:14}}>
          <span>✉️ {t("Contactează suportul")}</span><span style={{color:"var(--text-3)"}}>›</span>
        </button>
        {[["termeni","📄 "+t("Termeni și condiții")],["gdpr","🔒 "+t("Confidențialitate (GDPR)")]].map(([k,l])=>(
          <div key={k} style={{borderBottom:"1px solid var(--border)"}}>
            <button onClick={()=>setOpenLegal(o=>o===k?null:k)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",width:"100%",background:"none",border:"none",color:"var(--text)",padding:"12px 0",cursor:"pointer",fontFamily:"inherit",fontSize:14}}>
              <span>{l}</span><span style={{color:"var(--text-3)"}}>{openLegal===k?"▾":"›"}</span>
            </button>
            {openLegal===k&&<div style={{fontSize:12,color:"var(--text-2)",lineHeight:1.7,padding:"0 0 14px"}}>{t(LEGAL_TEXT[k])}</div>}
          </div>
        ))}
        <div style={{fontSize:11,color:"var(--text-4)",padding:"12px 0"}}>{t("Fișă Medicală · versiune web")}</div>
      </div>

      {/* Cont — acțiuni */}
      <div className="card" style={{marginTop:16,display:"flex",flexDirection:"column",gap:10}}>
        <button className="bg" onClick={onSignOut}>{t("⎋ Deconectare")}</button>
        {onDeleteProfile ? (
          // Pe un profil secundar (ex. Viorel) se poate șterge DOAR acel profil.
          // Contul propriu se gestionează din profilul principal.
          <>
            <button className="bg" style={{color:"var(--red)",borderColor:"var(--red-bg)"}} onClick={onDeleteProfile}>🗑 {t("Șterge profilul")} „{activeProfileName}"</button>
            <div style={{fontSize:11,color:"var(--text-3)",lineHeight:1.5}}>{t("Șterge doar acest profil și datele lui. Contul tău rămâne. Pentru a gestiona contul, treci pe profilul tău.")}</div>
          </>
        ) : (
          <>
            <button className="bg" style={{color:"var(--red)",borderColor:"var(--red-bg)"}} onClick={onDeleteAccount}>🗑 {t("Șterge tot contul")} ({email})</button>
            <div style={{fontSize:11,color:"var(--text-3)",lineHeight:1.5}}>{t("Șterge definitiv contul tău și ")}<strong>{t("toate")}</strong>{t(" profilurile din el. Ireversibil.")}</div>
          </>
        )}
      </div>
    </div>
  );
}

const LEGAL_TEXT = {
  termeni: "Fișă Medicală este un instrument personal de organizare a informațiilor medicale. Nu oferă sfaturi, diagnostice sau tratamente medicale și nu înlocuiește consultul unui medic. Ești responsabil(ă) pentru corectitudinea datelor introduse. Rezumatele și interpretările generate de AI sunt orientative și pot conține erori — verifică-le întotdeauna cu un medic. Prin folosirea aplicației accepți acești termeni.",
  gdpr: "Datele tale medicale sunt stocate securizat și sunt vizibile doar ție și persoanelor cărora le acorzi explicit acces (îngrijitori, medici). Nu vindem și nu partajăm datele cu terți. Poți exporta sau șterge oricând toate datele din contul tău, inclusiv ștergerea definitivă a contului din această secțiune. Documentele încărcate sunt accesibile prin linkuri temporare, care expiră automat. Pentru orice solicitare legată de datele tale personale, folosește butonul de contact al suportului.",
};
